export default __webpack_public_path__ + "static/media/image-cover.94512c48.jpg";